/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
 export const data_source = {
    url: 'http://localhost:17993/',
    token: '1eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6InJvZG9sZm9AZ21haWwuY29tIiwiaWF0IjoxNjM5NDczMjc2LCJleHAiOjE2Mzk2NDYwNzZ9.zMIXUVoHttdYSUnOce837RaZ9lXyMrH8PT1YfUTK2sk',
    prod:true,
    data_prod:true
  };
  
  //https://proyectosdesarrollo.com:17998/
  //http://localhost:17993/